import { Subject, Course, Grade, Bookable, Unit, Teacher, Pattern } from 'src/store/models/timetable/index.js'
import { LessonGrade, LessonBookable, LessonTeacher, SubstitutedLesson } from 'src/store/models/pivot/index.js'
import { CRUD } from 'src/store/models/helper/CRUD.js'

export class Lesson extends CRUD {
  static entity = 'lessons'
  static fetchUrl = '/users/self/timetable/lessons'

  static fields () {
    return {
      id: this.attr(null),
      lesson_id: this.attr(null),
      school_id: this.attr(null),
      period_id: this.attr([]),
      name: this.string('').nullable(),
      description: this.string('').nullable(),
      intern_id: this.attr([]),
      intern_data: this.attr([]),
      created_at: this.attr([]),
      updated_at: this.attr([]),
      course_id: this.attr(null),
      course: this.belongsTo(Course, 'course_id'),
      grades_pivot: this.hasMany(LessonGrade, 'lesson_id'),
      grades: this.belongsToMany(Grade, LessonGrade, 'lesson_id', 'grade_id'),
      teachers_pivot: this.hasMany(LessonTeacher, 'lesson_id'),
      teachers: this.belongsToMany(Teacher, LessonTeacher, 'lesson_id', 'teacher_id'),
      bookables_pivot: this.hasMany(LessonBookable, 'lesson_id'),
      bookables: this.belongsToMany(Bookable, LessonBookable, 'lesson_id', 'bookable_id'),
      // todo: remove units
      units: this.hasMany(Unit, 'lesson_id'),
      hour: this.number(null).nullable(),
      day: this.number(null).nullable(),
      dates: this.attr([]),
      time_begins_at: this.number(0),
      time_ends_at: this.number(0),
      time_id: this.attr(null),
      date: this.number(null).nullable(),
      pattern_id: this.attr(null),
      pattern: this.hasOne(Pattern, 'pattern_id'),
      kind: this.string(null).nullable(),
      comment: this.string(null).nullable(),
      substituted_pivot: this.hasMany(SubstitutedLesson, 'lesson_id'),
      substituted_lesson_pivot: this.hasMany(SubstitutedLesson, 'target_id'),
      substituted_lessons: this.belongsToMany(Lesson, SubstitutedLesson, 'target_id', 'lesson_id'),
      substituted_target_lessons: this.belongsToMany(Lesson, SubstitutedLesson, 'lesson_id', 'target_id'),
      subject_id: this.attr(null),
      subject: this.belongsTo(Subject, 'subject_id'),
      displayEntities: this.attr(null),
      meta: this.attr({})
    }
  }

  static beforeCreate (modal) {
    if (modal.dates && modal.dates.length) return

    if (modal.date) {
      modal.dates = [modal.date]
    }
  }

  static relations = [
    { entity: LessonTeacher, key: 'lesson_id' },
    { entity: LessonGrade, key: 'lesson_id' },
    { entity: LessonBookable, key: 'lesson_id' }
  ]
}

export default Lesson
